var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentSection)?_c('v-layout',{attrs:{"column":""}},[_c('sx-html',{attrs:{"text":_vm.currentSection.custom_element}})],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }